import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    alignItems: "left",
    flexDirection: "column",
    textAlign: "left",
  },
  paragraph: {
    marginBottom: 10,
  },
  subTitle: {
    fontSize: "0.95rem",
    fontWeight: 500,
  },
  text: {
    fontSize: ".85rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
}));

const LegalPlaceText: FC<WrappedComponentProps> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.content}>
      <Box className={classes.paragraph}>
        <Typography className={classes.text}>
          Profitez d'une réduction spéciale de <strong>-15%</strong> avec le
          code promo
          <strong> SAPHEER2025</strong>
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>• Facilité </Typography>
        <Typography className={classes.text}>
          Formulaires intelligents à remplir en 2 min.
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>• Réactivité </Typography>
        <Typography className={classes.text}>
          Les statuts sont révisés par des formalistes dans les 24h.
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>• Transparence </Typography>
        <Typography className={classes.text}>
          Accès facile au suivi de votre dossier.
        </Typography>
      </Box>
    </Box>
  );
};

export default injectIntl(LegalPlaceText);
